module.exports = __webpack_public_path__ + "img/content3.02395ee3.png";